module.exports = __webpack_public_path__ + "img/product-shot_09_loading.7ea4150a.jpg";